import { useContext, useEffect } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { HSStaticMethods } from "preline";
import { Helmet } from "react-helmet-async";
import Navbar from "./components/Navbar";
import {
  Dashboard,
  AuthPage,
  Home,
  InvitationPage,
  CreateInvitationPage,
  EditInvitationPage,
  InvitationDashboard,
  SuccessPaymentPage,
  NotFound,
} from "./pages";
import { AlertComponent, Modal } from "./components";
import { AuthContext } from "./context/AuthContext";

function App() {
  const location = useLocation();
  const { auth } = useContext(AuthContext);

  useEffect(() => {
    import("preline/preline");
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      HSStaticMethods.autoInit();
    }, 500);

    return () => clearTimeout(timer);
  }, [location.pathname]);

  const showNavbar =
    [
      "/auth",
      "/moje-pozivnice",
      "/nova-pozivnica",
      "/uspjesna-kupovina",
      "/404",
    ].includes(location.pathname) ||
    location.pathname === "/" ||
    location.pathname.startsWith("/uzvanici") ||
    location.pathname.startsWith("/uredi-pozivnicu");
  return (
    <>
      <Helmet>
        <meta name="color-scheme" content="light only" />
        <meta name="theme-color" content="#ffffff" />
        <meta name="forced-colors" content="none" />
        <style>
          {`
            body {
              background-color: #ffffff;
              color: #000000;
            }
            @media (prefers-color-scheme: dark) {
              body {
                background-color: #ffffff !important;
                color: #000000 !important;
              }
            }
          `}
        </style>
      </Helmet>
      {showNavbar && <Navbar prelineLoaded={true} />}
      <AlertComponent />
      <Modal />
      <Modal />
      <Routes>
        <Route path="/auth" element={<AuthPage />} />
        <Route
          path="/moje-pozivnice"
          element={
            <ProtectedRoute user={auth.user} isLoading={auth.isLoading}>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/nova-pozivnica"
          element={
            <ProtectedRoute user={auth.user} isLoading={auth.isLoading}>
              <CreateInvitationPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/uredi-pozivnicu/:rsvpId"
          element={
            <ProtectedRoute user={auth.user} isLoading={auth.isLoading}>
              <EditInvitationPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/uzvanici/:rsvpId"
          element={
            <ProtectedRoute user={auth.user} isLoading={auth.isLoading}>
              <InvitationDashboard />
            </ProtectedRoute>
          }
        />

        <Route path="uspjesna-kupovina" element={<SuccessPaymentPage />} />
        <Route path="/404" element={<NotFound />} />
        <Route path="/:rsvpId" element={<InvitationPage />} />
        <Route path="/" element={<Home />} />
      </Routes>
    </>
  );
}

const ProtectedRoute = ({
  user,
  isLoading,
  redirectPath = "/auth",
  children,
}) => {
  if (isLoading) {
    return (
      <div className="flex justify-center mt-4">
        <span
          className="animate-spin inline-block w-8 h-8 border-4 border-current border-t-transparent text-white rounded-full"
          role="status"
          aria-label="loading"
        ></span>
      </div>
    );
  }
  if (!user) {
    return <Navigate to={redirectPath} replace />;
  }

  return children;
};

export default App;
